export const VisitorParkingColors = {
  visitorParkingBg: '#fbfbfb' as const,
  visitorParkingErrorBg: '#fbf0f0' as const,
  visitorParkingErrorBorder: '#f5d4d2' as const,
  visitorParkingErrorText: '#ce2c21' as const,
  visitorParkingPhotoBg: '#1f1e21' as const,
  visitorParkingSuccessText: '#548671' as const,
}

export type VisitorParkingColorsType = typeof VisitorParkingColors
